import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import "./index.scss";

export default function FunctionalAreasList() {
  const functionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const navigate = useNavigate();

  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();

  return (
    <Grid container className="allPlans-functionalAreasList">
      {functionalAreaList?.map((element: any) => {
        return (
          <Grid
            item
            sx={{ background: element.theme.bgColor }}
            className="allPlans-functionalAreasList-item"
            key={element.id}
            onClick={() => {
              navigate(`/functionalArea/${element.id}`);
            }}
          >
            <Box className="allPlans-functionalAreasList-item-name">
              <Typography
                variant={isMobileScreen ? "label" : "body1"}
                changeVariant={false}
                color={element.theme.textColor}
                showBold
              >
                {element.name}
              </Typography>
            </Box>
            <Box>
              <img src={element.media.url} alt={element.name} />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
